//LIBRARY
import React from "react";

//RENDER
import ProgramDetail from "./render/Program.Detail";

//FUNCTION
import ProgramFirstLoad from "./functions/Program.FirstLoad";

import { FunctionGetPathUrl } from "../../utils/useFunction";

const RenderInactive = () => {
  React.useEffect(() => {
    if (window !== undefined && window !== null) {
      window.location.href = "/";
    }
  }, []);
  return <div className=""></div>;
};

const RenderActive = ({ program, addons }) => {
  return (
    <ProgramDetail
      addons={addons}
      backgroundImage={`url("${program?.background}`}
      type={program?.type}
      program_des={program?.description}
      icon={
        <img
          className={` ${
            program?.master_type === "My Wash" ? " w-12 " : " w-11 "
          } md:w-w_75 `}
          src={FunctionGetPathUrl(program?.image_key)}
        />
      }
      title={program?.name}
      master_id={program?._id}
    />
  );
};

const ProgramMain = React.memo(({ programs, addons, page = "mywash" }) => {
  const [program, setProgram] = React.useState(null);
  const [splitProgram, setSplitProgram] = React.useState(null);
  const [loaded, setLoaded] = React.useState(false);

  React.useEffect(() => {
    if (programs?.length > 0) {
      ProgramFirstLoad(setProgram, programs, setSplitProgram);
      setLoaded(true);
    }
  }, [programs]);

  // console.log("programs", { programs, program, splitProgram });
  // alert(
  //   `programs ${programs?.length} program ${program?.status} page=${page} `
  // );

  if (page === "mywash" && loaded) {
    return <RenderActive program={splitProgram?.wash} addons={addons} />;
  } else if (page === "myshoe" && loaded) {
    return <RenderActive program={splitProgram?.shoe} addons={addons} />;
  } else if (page === "myiron" && loaded) {
    return <RenderActive program={splitProgram?.iron} addons={addons} />;
  } else if (program?.status === true) {
    return <RenderActive program={program} addons={addons} />;
  } else if (program?.status === false) {
    return <RenderInactive />;
  } else {
    return <div className="bg-white w-screen h-screen"></div>;
  }
});
export default ProgramMain;
